export const services = [
  {
    labels: "Store Locator",
  },
  {
    labels: "Enter My Power",
  },
  {
    labels: "Buying Guide",
  },
  {
    labels: "Frame Size",
  },
];

export const about = [
  {
    labels: "We Are Hiring",
  },
  {
    labels: "Refer & Earn",
  },
  {
    labels: "About Us",
  },
  {
    labels: "Lenskart Coupons",
  },
];

export const helps = [
  {
    labels: "FAQ's",
  },
];
